import React from "react";

export default function PublicOfferRus() {
  return (
    <div style={{ backgroundColor: "#000", color: "#fff", fontFamily: "sans-serif", padding: "40px 20px", minHeight: "100vh" }}>
      <div style={{ maxWidth: "900px", margin: "0 auto", fontSize: "10pt" }}>
        <h1 style={{ fontSize: "32px", marginBottom: "20px" }}>Публичная оферта</h1>
       <p style={{ marginBottom: "16px" }}>UAB AutoliderLT (торговая марка Autopodbor.lt)</p>
<p style={{ marginBottom: "16px" }}>Įmonės kodas: 306990900</p>
<p style={{ marginBottom: "16px" }}>Adresas: V. Nagevičiaus g. 3, LT-08237 Vilnius</p>
<p style={{ marginBottom: "16px" }}>Telefonas: +37061744495</p>
<p style={{ marginBottom: "24px" }}>Дата публикации оферты: 17.05.2025</p>


        <div style={{ lineHeight: "1.6" }}>
          <h2>1. Общие положения</h2>
          <p>1.1. Настоящая Оферта является официальным предложением заключить договор возмездного оказания услуг.</p>
          <p>1.2. Оферта не требует подписания в бумажной форме и имеет юридическую силу согласно Гражданскому кодексу Литовской Республики.</p>
          <p>1.3. Заказ услуг означает полное и безоговорочное принятие всех условий Оферты.</p>
          <p>1.4. Услуги оказываются исключительно в информационно-консультационных целях.</p>
          <p>1.5. Исполнитель не является продавцом автомобилей и не несёт ответственности за действия третьих лиц.</p>

          <h2>2. Предмет оферты</h2>
          <p>2.1. Исполнитель оказывает услуги по подбору, диагностике, консультированию, проверке и сопровождению покупки автомобилей.</p>
          <p>2.2. Объём услуг определяется выбранным Заказчиком пакетом на сайте Autopodbor.lt.</p>
          <p>2.3. Услуги могут оказываться дистанционно или очно.</p>
          <p>2.4. Все коммуникации ведутся через электронную почту, мессенджеры, телефон или сайт.</p>
          <p>2.5. Услуги считаются оказанными после предоставления отчёта/выполнения действий согласно пакету.</p>

          <h2>3. Права и обязанности сторон</h2>
          <p>3.1. Исполнитель обязуется:</p>
          <p>– Оказывать услуги качественно, в срок, с соблюдением заявленного объёма.</p>
          <p>– Информировать Заказчика о найденных вариантах, результатах диагностики и ходе работ.</p>
          <p>– Соблюдать конфиденциальность полученной информации.</p>
          <p>3.2. Исполнитель вправе:</p>
          <p>– Отказать в оказании услуг без объяснения причин до момента оплаты.</p>
          <p>– Прекратить оказание услуг при нарушении Заказчиком условий Оферты.</p>
          <p>– Самостоятельно принимать решения об отклонении сомнительных вариантов авто.</p>
          <p>3.3. Заказчик обязуется:</p>
          <p>– Предоставить корректную информацию и требования.</p>
          <p>– Оплатить выбранный пакет услуг до начала работ.</p>
          <p>– Поддерживать связь и оперативно отвечать на сообщения.</p>
          <p>3.4. Заказчик вправе:</p>
          <p>– Получать консультации по ходу подбора.</p>
          <p>– Повысить пакет услуг, оплатив разницу.</p>
          <p>– Прекратить сотрудничество (см. раздел 6).</p>

          <h2>4. Порядок оказания услуг</h2>
          <p>4.1. Работы начинаются после 100% предоплаты выбранного пакета.</p>
          <p>4.2. Подбор осуществляется в течение сроков, обозначенных в описании услуг (обычно от 1 до 15 рабочих дней) 30 рабочих дней максимальный срок.</p>
          <p>4.3. В случае увеличения сроков Исполнитель уведомляет Заказчика.</p>
          <p>4.4. В рамках пакета предоставляются отчёты, фото, видео и рекомендации.</p>
          <p>4.5. Заказчик сам принимает решение о покупке автомобиля.</p>
          <p>4.6. После завершения выбранного этапа услуги считаются оказанными.</p>

          <h2>5. Ответственность сторон</h2>
          <p>5.1. Исполнитель несёт ответственность только за услуги в рамках выбранного пакета.</p>
          <p>5.2. Исполнитель не гарантирует отсутствие скрытых дефектов в авто.</p>
          <p>5.3. Исполнитель не несёт ответственность за решение Заказчика о покупке.</p>
          <p>5.4. Заказчик несёт ответственность за свои действия после получения рекомендаций.</p>
          <p>5.5. Риски, связанные с дальнейшей регистрацией, ремонтом, использованием автомобиля, лежат на Заказчике.</p>
          <p>5.6. Выкуп автомобиля осуществляется Исполнителем за счёт и по поручению Заказчика. Передача денежных средств продавцу производится исключительно из средств, предоставленных Заказчиком.</p>
          <p>5.7. В случае экспорта автомобиля в другую страну, все таможенные сборы, налоги, пошлины, регистрационные и иные обязательные платежи оплачиваются Заказчиком самостоятельно либо через Исполнителя, при условии предварительного предоставления соответствующих средств. Исполнитель не несёт ответственности за задержки, отказы или действия таможенных и иных государственных органов в стране назначения.</p>

          <h2>6. Финансовые условия и возвраты</h2>
          <p>6.1. Оплата услуг производится по безналичному расчёту или переводом, если другого небыло согласовано с заказчиком.</p>
          <p>6.2. В случае прекращения подбора по инициативе Заказчика возврат средств возможен только с учётом объёма уже выполненных работ.</p>
          <p>6.3. Возврат осуществляется в течение 14 рабочих дней после письменного запроса.</p>
          <p>6.4. Пакеты возврату не подлежат, если услуги были оказаны полностью.</p>
          <p>6.5. Повышение пакета осуществляется с доплатой разницы.</p>
          <p>6.6. В случае отказа от покупки рекомендованного авто повторный подбор оплачивается отдельно.</p>

          <h2>7. Отказ от ответственности</h2>
          <p>7.1. Исполнитель оценивает техническое и визуальное состояние автомобиля исключительно на момент его осмотра и диагностики, в пределах предусмотренного пакетом услуг. При этом вся выявленная информация добросовестно отражается в отчёте. Исполнитель не может нести ответственность за изменения, которые могут произойти с автомобилем после проверки, включая технические неисправности, вмешательства третьих лиц или последствия эксплуатации. Решение о покупке автомобиля Заказчик принимает самостоятельно, на основании предоставленных данных.</p>
          <p>7.2. Исполнитель не выступает в роли продавца и не получает комиссию от продажи.</p>
          <p>7.3. Исполнитель не гарантирует успешную регистрацию авто в другой стране.</p>
          <p>7.4. Все выводы носят рекомендательный характер.</p>
          <p>7.5. В случае отказа Заказчика от следования рекомендациям, Исполнитель ответственности не несёт.</p>

          <h2>8. Форс-мажор</h2>
          <p>8.1. Стороны освобождаются от ответственности при наступлении обстоятельств непреодолимой силы (форс-мажора).</p>
          <p>8.2. К таким обстоятельствам относятся: война, стихийные бедствия, эпидемии, блокировки счетов, действия госорганов и др.</p>
          <p>8.3. Сроки выполнения обязательств переносятся на период действия форс-мажора.</p>

          <h2>9. Конфиденциальность</h2>
          <p>9.1. Все переданные Заказчиком данные используются исключительно для выполнения заказа.</p>
          <p>9.2. Исполнитель не передаёт информацию третьим лицам без согласия Заказчика.</p>
          <p>9.3. Отзывы, фото и видео могут быть использованы в портфолио только по согласованию.</p>

          <h2>10. Заключительные положения</h2>
          <p>10.1. Настоящая Оферта действует бессрочно и может быть изменена без предварительного уведомления.</p>
          <p>10.2. Все споры решаются путём переговоров, при невозможности — в соответствии с законодательством Литвы.</p>
          <p>10.3. Факт оплаты услуг подтверждает согласие с Офертой.</p>
          <p>10.4. Электронные переписки, мессенджеры и документы считаются юридически значимыми.</p>
          <p>10.5. Все условия, не прописанные явно, регулируются в рамках стандартного договора оказания услуг.</p>
        </div>
      </div>
    </div>
  );
}
